import { Button, Paper } from '@material-ui/core';
import AudioPlayer from './AudioPlayer';
import { API_V4_BASE_URL } from 'settings';
import { downloadAudioFile } from 'actionCreators/lessons';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  retryButton: {
    margin: '12px',
    padding: '12px',
  },
  retryLabelError: {
    margin: '12px',
  },
}));

const Audio = (props: any) => {
  const { embed, id, download_enabled } = props.content;
  const classes = useStyles();

  const reloadAudioFile = async (lessonContentId: number) => {
    await downloadAudioFile(lessonContentId);
  };

  const renderAudioContent = () => {
    if (!embed) {
      return (
        <Paper className={classes.retryButton}>
          <Button variant='outlined' onClick={() => reloadAudioFile(id)}>
            Tentar novamente
          </Button>
          <span className={classes.retryLabelError}>Não foi possível carregar o áudio.</span>
        </Paper>
      );
    }

    const url = `${embed.startsWith('http') ? '' : API_V4_BASE_URL}${embed}`;
    return (
      <div className='audio-container'>
        <AudioPlayer src={url} enabledDownload={!!download_enabled} />
      </div>
    );
  };

  return renderAudioContent();
};

export default Audio;
